module.exports = __webpack_public_path__ + "img/20.3ead6200.png";